import { cn } from '@sglara/cn';
import CheckCircleFilledIcon from 'design-system/src/assets/icons/checkCircleFilled.svg?react';
import { Typography } from 'design-system/src/components/Typography/Typography';

export type EhrIntegrationSuccessCardProps = {
  /**
   * Class name for additional styling
   */
  className?: string;
  /**
   * The EHR display name to show in the success message
   */
  ehrDisplayName: string;
};

/**
 * Success card component displayed after EHR integration form submission
 */
export const EhrIntegrationSuccessCard = ({ className, ehrDisplayName }: EhrIntegrationSuccessCardProps) => {
  return (
    <div
      className={cn(
        '@container',
        '@[600px]:w-full mx-auto my-4 box-border flex w-[600px] flex-col gap-6 rounded-md border border-solid border-gray-100 bg-white p-8 shadow-container',
        className,
      )}
    >
      <div className="flex flex-col items-center gap-6">
        <CheckCircleFilledIcon className="size-8 shrink-0 text-green-500" aria-hidden />
        <Typography>
          Setup with {ehrDisplayName} takes <span className="font-bold">1-2 business days</span>. You'll get a
          confirmation email once it's complete.
        </Typography>
      </div>
    </div>
  );
};

export default EhrIntegrationSuccessCard;
